import React from "react";
import { PhoneNumberFormItem } from "./PhoneNumberFormItem";

export const PhoneNumberItem = ({ name, typeName, ...props }) => {
  const typeFieldName = [...name.slice(0, -1), typeName];

  return <PhoneNumberFormItem typeName={typeFieldName} name={name} {...props} />;
};
